import { ListColumn, ListColumnAlignment } from '@/interfaces'
import { computed } from 'vue'

const activeApiKeysCols = computed<ListColumn[]>(() => {
  return [
    {
      name: 'label',
      title: 'api-keys-name',
      width: 20,
      alignment: ListColumnAlignment.Left,
      sortable: true,
      position: 1,
      priority: 1,
      expand: true
    },
    {
      name: 'prefix',
      title: 'api-keys-public-key',
      width: 30,
      alignment: ListColumnAlignment.Left,
      sortable: false,
      position: 2,
      priority: 2
    },
    {
      name: 'created_at',
      title: 'api-keys-created',
      width: 20,
      alignment: ListColumnAlignment.Left,
      sortable: true,
      position: 3,
      priority: 3
    },
    {
      name: 'actions',
      title: '',
      width: 15,
      alignment: ListColumnAlignment.Left,
      sortable: false,
      position: 4,
      priority: 0
    }
  ]
})

export default activeApiKeysCols
